import medicalSpecialitiesServices from '@/modules/MedicalSpecialities/services'
import { AttendanceLimitResponse } from '@/modules/MedicalSpecialities/types'
import httpClient from '@/services/httpClient'
import { HealthPlanCardFormData } from './components/modal/HealthPlanCard/types'

type VerifyFreeAttendance = {
  preferenceType?: string
  date?: string
  council?: string
  specialityId?: string | number
  attendanceType?: 'AGENDADO' | 'IMEDIATO'
  professionalType?: string
  rescheduleToken?: string
}

export const verifyFreeAttendances = ({
  preferenceType,
  date,
  council,
  attendanceType,
  professionalType,
  specialityId,
  rescheduleToken,
}: VerifyFreeAttendance): Promise<AttendanceLimitResponse> => {
  const LOCALE = 'pt-BR'
  const NOW = new Date()
  const attendanceDate =
    date || new Intl.DateTimeFormat(LOCALE).format(NOW).replace(/\//g, '-')

  let attendanceLimitPayload
  if (preferenceType === 'from_without_preference') {
    attendanceLimitPayload = {
      date: attendanceDate,
      attendanceType,
      professionalType: council?.toUpperCase(),
      rescheduleToken,
    }
  } else {
    professionalType?.toLowerCase() === 'medico'
      ? (attendanceLimitPayload = {
          council: council?.toUpperCase(),
          professionalType: professionalType?.toUpperCase(),
          attendanceType,
          date: attendanceDate,
          specialityId: specialityId,
          rescheduleToken,
        })
      : (attendanceLimitPayload = {
          council: council?.toUpperCase(),
          professionalType: professionalType?.toUpperCase(),
          attendanceType,
          date: attendanceDate,
          rescheduleToken,
        })
  }

  return medicalSpecialitiesServices.getAttendanceLimit(attendanceLimitPayload)
}

export const checkProfessionalTeam = async (
  idProfissional: number,
): Promise<boolean> => {
  const response = await httpClient.get(
    `/primary-health-care/has-professional-in-patient-team/${idProfissional}`,
  )

  return response?.data?.object
}

export const updateHealthCard = async (
  params: HealthPlanCardFormData,
): Promise<boolean> => {
  const { data } = await httpClient.put(
    `/paciente/alterar/carteirinha/${params?.healthPlanCard}`,
  )
  return data.object
}

export const checkHealthPlanCardEligibility = async (
  params: HealthPlanCardFormData,
): Promise<boolean> => {
  const { data } = await httpClient.post(
    `/integration/app-empresa-externa/elegibilidade/validar/`,
    {
      carteiraConvenio: `${params?.healthPlanCard}`,
    },
  )
  return data.object
}
